import React, { useState, useCallback } from "react";
import { withRouter } from "react-router-dom";
import { Form, Button, Row, Col, Card, Table, Modal, Spinner, Container } from 'react-bootstrap';
import { Formik, Field } from 'formik';
import { default as Selector } from 'react-select';
import { useSelector } from 'react-redux'
import { FaSearch, FaFileExcel, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { MdEdit } from "react-icons/md";
import { salvarEmExcel } from "~/Utils/Helpers";
import { format } from "~/Utils/Helpers";
import { DATETIME_DEFAULT_SHORT_FORMAT, caracteristicas } from "~/constant";
import AuthStorage from '~/Utils/AuthStorage';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';
import Loading from '~/Components/Loading';

export function formatFilaStatus(count) {
    if (!Number.isInteger(count) || count < 0) return '-';
    return count > 0 ? `Sim: ${count}` : 'Não';
}

// Modal de edição memoizado para evitar re-renderizações desnecessárias
const EditReservaModalMemo = React.memo(function EditReservaModalMemo({
    show,
    reserva,
    validade,
    motivo,
    loading,
    canEdit,
    validadeError,
    minValidade,
    onClose,
    onChangeValidade,
    onChangeMotivo,
    onUpdate,
}) {
    return (
        <Modal show={show} onHide={onClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Manutenção da reserva</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {reserva && (
                    <div className="container-fluid">
                        {loading && (
                            <div className="d-flex align-items-center gap-2 mb-3" aria-live="polite">
                                <Spinner animation="border" size="sm" role="status" />
                                <span>Atualizando...</span>
                            </div>
                        )}
                        <Row className="gy-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Empreendimento:</Form.Label>
                                    <Form.Control value={reserva.empreendimento || ''} disabled />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>QD/LT:</Form.Label>
                                    <Form.Control value={`${reserva.quadra || ''} / ${reserva.lote || ''}`} disabled />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Qtd Fila:</Form.Label>
                                    <Form.Control value={reserva.fila ? '1' : '0'} disabled />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Reserva de:</Form.Label>
                                    <Form.Control value={reserva.nome_completo || ''} disabled />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Imobiliária:</Form.Label>
                                    <Form.Control value={reserva.imobiliaria || ''} disabled />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Reservado em:</Form.Label>
                                    <Form.Control
                                        type="datetime-local"
                                        value={reserva.data_emissao} disabled />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Tempo Restante (min):</Form.Label>
                                    <Form.Control
                                        value={reserva.tempo}
                                        disabled
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Validade:</Form.Label>
                                    <Form.Control
                                        type="datetime-local"
                                        value={validade}
                                        onChange={(e) => onChangeValidade((e.target.value))}
                                        min={minValidade}
                                        isInvalid={!!validadeError}
                                        disabled={!canEdit}
                                    />
                                    <Form.Control.Feedback type="invalid">{validadeError}</Form.Control.Feedback>
                                    {!canEdit && (
                                        <Form.Text className="text-muted">Sem permissão para editar</Form.Text>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Motivo:</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={motivo}
                                        onChange={(e) => onChangeMotivo(e.target.value)}
                                        autoFocus
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>Fechar</Button>
                <Button variant="success" onClick={onUpdate} disabled={loading || !canEdit || !!validadeError} >
                    {loading ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-2" /> Atualizando...
                        </>
                    ) : (
                        'Atualizar Reserva'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
});


const ControlePdv = () => {

    const empreendimentos = useSelector(state => state.empreendimentos);
    const corretores = useSelector(state => state.corretor);
    const [loading, setLoading] = useState(false);
    const [consulta, setConsulta] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasSearched, setHasSearched] = useState(false);
    const itemsPerPage = 10;

    // Estado para edição via modal
    const [showEditModal, setShowEditModal] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [editReserva, setEditReserva] = useState(null);
    const [editValidade, setEditValidade] = useState('');
    const [editMotivo, setEditMotivo] = useState('');
    const [editMotivoDraft, setEditMotivoDraft] = useState('');
    const [editModalLoading, setEditModalLoading] = useState(false);
    const [editValidadeError, setEditValidadeError] = useState('');

    // Estado para confirmação de exclusão
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteIndexPending, setDeleteIndexPending] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(false);

    const toLocalInputValue = (date) => {
        const d = new Date(date);
        const pad = (n) => String(n).padStart(2, '0');
        const yyyy = d.getFullYear();
        const mm = pad(d.getMonth() + 1);
        const dd = pad(d.getDate());
        const hh = pad(d.getHours());
        const mi = pad(d.getMinutes());
        return `${yyyy}-${mm}-${dd}T${hh}:${mi}`;
    };


    // Modal de confirmação: abrir/cancelar/confirmar
    const openDeleteModal = (rowIndex) => {
        setDeleteIndexPending(rowIndex);
        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setShowDeleteModal(false);
        setDeleteIndexPending(null);
    };

    const confirmDelete = async () => {
        setDeleteLoading(true);
        try {
            const selected = deleteIndexPending !== null ? consulta[deleteIndexPending] : null;
            const codigo = selected && (selected.codigo_ativo || selected.codigo);
            if (!codigo) {
                throw new Error('Código do ativo não encontrado.');
            }

            const response = await api.excluirReserva(codigo);
            const message = (response && response.message) ? response.message : 'Reserva excluída com sucesso.';
            toast.success(message);

            setConsulta(prev => prev.filter((_, i) => i !== deleteIndexPending));
        } catch (err) {
            toast.error(err && err.message ? err.message : 'Falha ao excluir reserva.');
        } finally {
            setDeleteLoading(false);
            closeDeleteModal();
        }
    };

    const openEditModal = (item, rowIndex) => {
        setEditIndex(rowIndex);
        setEditReserva(item);
        setEditValidade(item && item.data_validade ? item.data_validade : toLocalInputValue(new Date()));
        const motivoInicial = item && item.motivo_atualizar ? item.motivo_atualizar : '';
        setEditMotivo(motivoInicial);
        setEditMotivoDraft(motivoInicial);
        setShowEditModal(true);
    };

    const handleUpdateReserva = async () => {
        try {
            setEditModalLoading(true);
            const podeEditarReserva = AuthStorage.isADM() || AuthStorage.isGerente() || AuthStorage.temCaracteristica(caracteristicas.TransfereReserva);
            if (!podeEditarReserva) {
                toast.error('Você não tem permissão para editar.');
                setEditModalLoading(false);
                return;
            }
            if (editValidadeError) {
                toast.error(editValidadeError);
                setEditModalLoading(false);
                return;
            }
            if (!editValidade) {
                toast.error('Informe a validade.');
                setEditModalLoading(false);
                return;
            }
            // Usa o draft para garantir último valor digitado
            const motivoFinal = editMotivoDraft;
            if (!motivoFinal || !motivoFinal.trim()) {
                toast.error('Informe o motivo antes de atualizar.');
                setEditModalLoading(false);
                return;
            }
            // Envio ao servidor
            try {
                await api.atualizarReserva({
                    codigo_ticket: editReserva && editReserva.codigo_ticket ? editReserva.codigo_ticket : null,
                    data_vencimento_anterior: editReserva && editReserva.data_validade ? editReserva.data_validade : null,
                    nova_validade: editValidade,
                    motivo: motivoFinal.trim(),
                    sequencia: editReserva && editReserva.sequencia ? editReserva.sequencia : null,
                    codigo_usuario: editReserva && editReserva.codigo_usuario ? editReserva.codigo_usuario : null,
                });
            } catch (serverErr) {
                toast.error('Falha ao enviar atualização ao servidor.');
                setEditModalLoading(false);
                return;
            }
            // Buscar dados mais recentes e atualizar conteúdo do modal
            try {
                const listaAtualizada = await api.consultarControlePdv({});
                let atualizado = null;
                if (Array.isArray(listaAtualizada)) {
                    atualizado = listaAtualizada.find(it => String(it.codigo_ativo) === String(editReserva && editReserva.codigo_ativo ? editReserva.codigo_ativo : '')) || null;
                } else if (listaAtualizada && typeof listaAtualizada === 'object') {
                    atualizado = listaAtualizada;
                }
                if (atualizado) {
                    setEditReserva(atualizado);
                    setEditValidade(atualizado.validade || editValidade);
                    setEditMotivoDraft(atualizado.motivo != null ? atualizado.motivo : motivoFinal.trim());
                    setConsulta((prev) => prev.map((it, i) => (
                        i === editIndex ? { ...it, ...atualizado } : it
                    )));
                } else {
                    // Fallback: atualiza somente os campos alterados
                    setConsulta((prev) => prev.map((it, i) => (
                        i === editIndex ? { ...it, validade: editValidade, motivo: motivoFinal.trim() } : it
                    )));
                }
                toast.success('Reserva atualizada com sucesso.');
            } catch (refreshErr) {
                toast.error('Atualização realizada, mas falhou ao consultar dados mais recentes.');
            } finally {
                setEditModalLoading(false);
            }
        } catch (err) {
            setEditModalLoading(false);
            toast.error('Erro ao atualizar a reserva.');
        }
    };


    const optionsEmpreendimentos = [
        ...empreendimentos.sort.map(item => ({
            value: item.codigo,
            label: item.codigo + ' - ' + item.descricao,
        })),
    ];
    const optionsCorretores = [
        ...corretores.listaCorretores.map(cor => ({
            value: cor.codigo,
            label: cor.codigo + ' - ' + cor.nome,
        })),
    ];
    const consultarControlePdv = async (filtro = {}) => {
        try {
            setLoading(true);
            const resultado = await api.consultarControlePdv(filtro);
            setConsulta(resultado || []);
            setHasSearched(true);
        } catch (error) {
            toast.error(error.message || 'Erro ao consultar');
        } finally {
            setLoading(false);
            setCurrentPage(1);
        }
    };

    // Callbacks estáveis para o modal memoizado
    const handleCloseEditModal = useCallback(() => setShowEditModal(false), []);
    const handleChangeValidade = useCallback((value) => {
        setEditValidade(value);
        const emissao = editReserva && editReserva.data_emissao ? new Date(editReserva.data_emissao) : new Date();
        const val = new Date(value);
        if (!value) {
            setEditValidadeError('Informe a validade.');
        } else if (isNaN(val.getTime())) {
            setEditValidadeError('Data inválida.');
        } else if (val < emissao) {
            setEditValidadeError('Validade deve ser posterior à emissão.');
        } else {
            setEditValidadeError('');
        }
    }, [editReserva]);
    const handleChangeMotivo = useCallback((value) => setEditMotivoDraft(value), []);

    // Modal de confirmação de exclusão
    const ConfirmDeleteModal = () => {
        const selected = deleteIndexPending !== null ? consulta[deleteIndexPending] : null;

        return (
            <Modal
                show={showDeleteModal}
                onHide={closeDeleteModal}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Cancelamento da reserva</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Tem certeza de que deseja excluir a reserva?</p>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '8px',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                        }}
                    >
                        <small>
                            Id: <strong>{selected ? selected.codigo_ativo : '-'}</strong>
                        </small>
                        <small>
                            Nome: <strong>{selected ? selected.empreendimento : '-'}</strong>
                        </small>
                        <small>
                            Quadra: <strong>{selected ? selected.quadra : '-'}</strong>
                        </small>
                        <small>
                            Lote: <strong>{selected ? selected.lote : '-'}</strong>
                        </small>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '8px',
                            flexWrap: 'wrap',
                            marginTop: '8px',
                            justifyContent: 'space-between',
                        }}
                    >
                        <small>
                            Reservado:{' '}
                            <strong>
                                {selected && selected.data_emissao ? format.date(selected.data_emissao, DATETIME_DEFAULT_SHORT_FORMAT) : '-'}
                            </strong>
                        </small>
                        <small>
                            Vencimento:{' '}
                            <strong>
                                {selected && selected.data_validade ? format.date(selected.data_validade, DATETIME_DEFAULT_SHORT_FORMAT) : '-'}
                            </strong>
                        </small>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={closeDeleteModal}
                    >
                        Não
                    </Button>
                    <Button
                        variant="danger"
                        disabled={deleteLoading}
                        onClick={confirmDelete}
                    >
                        {deleteLoading ? <>Excluindo...</> : <>Sim</>}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    const tableStyles = {
        wrapper: {
            borderRadius: '8px',
            overflow: 'hidden',
            border: '1px solid #dee2e6',
        },
        header: {
            backgroundColor: '#0747a6',
            color: '#fff',
            borderColor: '#0747a6',
            userSelect: 'none',
        },
    };

    const colunas = [
        { chave: 'empreendimento', label: 'Empreendimento' },
        { chave: 'codigo_ticket', label: 'Prospecto' },
        { chave: 'codigo_ativo', label: 'Ativo' },
        { chave: 'quadra', label: 'Quadra' },
        { chave: 'lote', label: 'Lote' },
        { chave: 'nome_completo', label: 'Corretor' },
        { chave: 'imobiliaria', label: 'Imobiliária' },
        { chave: 'tempo', label: 'Tempo (min)' },
        { chave: 'fila', label: 'Tem Fila?' },
        { chave: 'visitar_lote', label: 'Foi visitar lote?' },
    ];

    return (
        <Container fluid className="px-3 py-3">
            <style>
                {`
                    .tabela-controle-pdv tbody tr:hover {
                        background-color: #e8f4ff !important;
                    }

                    @media (max-width: 768px) {
                        .tabela-controle-pdv thead {
                            display: none;
                        }
                        .tabela-controle-pdv tbody tr {
                            display: block;
                            margin-bottom: 1rem;
                            border: 1px solid #dee2e6;
                            border-radius: 8px;
                            overflow: hidden;
                        }
                        .tabela-controle-pdv tbody td {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 0.75rem 1rem;
                            border: none;
                            border-bottom: 1px solid #eee;
                        }
                        .tabela-controle-pdv tbody td:last-child {
                            border-bottom: none;
                        }
                        .tabela-controle-pdv tbody td::before {
                            content: attr(data-label);
                            font-weight: 600;
                            color: #0747a6;
                            margin-right: 1rem;
                        }
                    }
                `}
            </style>

            <HeaderAzul title="Controle PDV" />

            <Card className="mb-2 shadow-sm">
                <Card.Body className="pt-2 pb-3 px-3">
                    <Formik
                        initialValues={{
                            empreendimento: '',
                            quadra: '',
                            lote: '',
                            corretor: ''
                        }}
                    >
                        {({ setFieldValue, values }) => (
                            <Form
                                onSubmit={async (e) => {
                                    e.preventDefault();
                                    const filtro = {
                                        codigo_familia: values.empreendimento ? values.empreendimento.value : null,
                                        quadra: values.quadra || null,
                                        lote: values.lote || null,
                                        codigo_usuario: values.corretor ? values.corretor.value : null,
                                    };
                                    await consultarControlePdv(filtro);
                                }}
                            >
                                <Row className="align-items-end">
                                    <Col xs={12} sm={6} lg={3}>
                                        <Form.Group className="mb-0">
                                            <Form.Label>Empreendimento</Form.Label>
                                            <Selector
                                                styles={customStyles}
                                                components={{ DropdownIndicator }}
                                                name="empreendimento"
                                                options={optionsEmpreendimentos}
                                                value={values.empreendimento}
                                                isSearchable={true}
                                                isClearable={true}
                                                onChange={(selected) => setFieldValue('empreendimento', selected)}
                                                placeholder="Todos..."
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col xs={6} sm={4} lg={1}>
                                        <Form.Group className="mb-0">
                                            <Form.Label>Quadra</Form.Label>
                                            <Field
                                                type="text"
                                                name="quadra"
                                                className="form-control"
                                                placeholder="Quadra"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col xs={6} sm={4} lg={1}>
                                        <Form.Group className="mb-0">
                                            <Form.Label>Lote</Form.Label>
                                            <Field
                                                type="text"
                                                name="lote"
                                                className="form-control"
                                                placeholder="Lote"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12} sm={6} lg={3}>
                                        <Form.Group className="mb-0">
                                            <Form.Label>Corretor</Form.Label>
                                            <Selector
                                                styles={customStyles}
                                                components={{ DropdownIndicator }}
                                                name="corretor"
                                                options={optionsCorretores}
                                                value={values.corretor}
                                                isClearable={true}
                                                onChange={(selected) => setFieldValue('corretor', selected)}
                                                placeholder="Todos..."
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col xs={hasSearched && consulta && consulta.length > 0 ? 6 : 12} sm={4} lg={2}>
                                        <Form.Group className="mb-0">
                                            <Button
                                                type="submit"
                                                variant="success"
                                                className="w-100"
                                                title="Buscar"
                                                disabled={loading}
                                            >
                                                <FaSearch /> Buscar
                                            </Button>
                                        </Form.Group>
                                    </Col>
                                    {hasSearched && consulta && consulta.length > 0 && (
                                        <Col xs={6} sm={4} lg={2}>
                                            <Form.Group className="mb-0">
                                                <Button
                                                    variant="success"
                                                    type="button"
                                                    onClick={async () => {
                                                        await salvarEmExcel(consulta, '/exportador/excel/controle-pdv');
                                                    }}
                                                    aria-label="Salvar em Excel"
                                                    title="Salvar em Excel"
                                                    className="w-100"
                                                >
                                                    <FaFileExcel /> Excel
                                                </Button>
                                            </Form.Group>
                                        </Col>
                                    )}
                                </Row>
                            </Form>
                        )}
                    </Formik>
                </Card.Body>
            </Card>

            {loading && <Loading label="Carregando reservas" />}

            {!loading && hasSearched && (!consulta || consulta.length === 0) && (
                <div className="text-center py-5">
                    <h5 className="mt-3 text-muted">Nenhum resultado encontrado</h5>
                    <p className="text-muted">
                        Não foram encontrados resultados para os filtros selecionados.
                    </p>
                </div>
            )}

            {!loading && consulta && consulta.length > 0 && (() => {
                const totalPaginas = Math.max(1, Math.ceil(consulta.length / itemsPerPage));
                const paginaCorrente = Math.min(currentPage, totalPaginas);
                const inicio = (paginaCorrente - 1) * itemsPerPage;
                const fim = inicio + itemsPerPage;
                const itensPagina = consulta.slice(inicio, fim);
                return (
                <>
                    <div style={tableStyles.wrapper}>
                        <Table bordered hover responsive className="mb-0 tabela-controle-pdv">
                            <thead>
                                <tr className="text-center">
                                    {colunas.map(col => (
                                        <th
                                            key={col.chave}
                                            style={tableStyles.header}
                                        >
                                            {col.label}
                                        </th>
                                    ))}
                                    <th style={tableStyles.header}>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itensPagina.map((item, localIndex) => {
                                    const index = inicio + localIndex;
                                    return (
                                    <tr key={index}>
                                        <td data-label="Empreendimento">{item.empreendimento}</td>
                                        <td data-label="Prospecto">{item.codigo_ticket}</td>
                                        <td data-label="Ativo" className="text-center">{item.codigo_ativo}</td>
                                        <td data-label="Quadra">{item.quadra}</td>
                                        <td data-label="Lote">{item.lote}</td>
                                        <td data-label="Corretor">{item.nome_completo}</td>
                                        <td data-label="Imobiliária">{item.imobiliaria}</td>
                                        <td data-label="Tempo (min)" className="text-center">{item.tempo}</td>
                                        <td data-label="Tem Fila?" className="text-center">
                                            {formatFilaStatus(Number(item.fila))}
                                        </td>
                                        <td data-label="Foi visitar lote?" className="text-center">
                                            {item.visitar_lote === '-' ? '-' : (String(item.visitar_lote).toUpperCase() === 'SIM' ? 'Sim' : 'Não')}
                                        </td>
                                        <td data-label="Ações" className="text-center">
                                            <Button
                                                variant="danger"
                                                size="sm"
                                                title="Excluir"
                                                aria-label="Excluir"
                                                onClick={() => openDeleteModal(index)}
                                            >
                                                <FaTrash />
                                            </Button>
                                            &nbsp;
                                            <Button
                                                variant="primary"
                                                size="sm"
                                                title="Editar"
                                                aria-label="Editar reserva"
                                                onClick={() => openEditModal(item, index)}
                                            >
                                                <MdEdit />
                                            </Button>
                                        </td>
                                    </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </div>

                    {consulta.length > itemsPerPage && (
                        <div className="d-flex justify-content-center align-items-center mt-3 gap-3">
                            <Button
                                variant="outline-primary"
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                disabled={paginaCorrente === 1}
                            >
                                Anterior
                            </Button>

                            <span>
                                Página {paginaCorrente} de {totalPaginas}
                            </span>

                            <Button
                                variant="outline-primary"
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPaginas))}
                                disabled={paginaCorrente === totalPaginas}
                            >
                                Próxima
                            </Button>
                        </div>
                    )}
                </>
                );
            })()}

            <EditReservaModalMemo
                show={showEditModal}
                reserva={editReserva}
                validade={editValidade}
                motivo={editMotivoDraft}
                loading={editModalLoading}
                canEdit={AuthStorage.isADM() || AuthStorage.isGerente() || AuthStorage.temCaracteristica(caracteristicas.TransfereReserva)}
                validadeError={editValidadeError}
                minValidade={editReserva && editReserva.data_emissao ? toLocalInputValue(editReserva.data_emissao) : toLocalInputValue(new Date())}
                onClose={handleCloseEditModal}
                onChangeValidade={handleChangeValidade}
                onChangeMotivo={handleChangeMotivo}
                onUpdate={handleUpdateReserva}
            />
            <ConfirmDeleteModal />
        </Container>
    );
};

export default withRouter(ControlePdv);
